import { render, staticRenderFns } from "./CollectionContainer.vue?vue&type=template&id=621d816e&"
import script from "./CollectionContainer.vue?vue&type=script&lang=ts&"
export * from "./CollectionContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports